import api from './api';
import type { LetzteAenderung, ZuletztBenutzt } from '../types';
import type { DashboardProfile, WidgetLayoutItem } from '../widgets/types';

export const getLetzteAenderungen = async (): Promise<LetzteAenderung[]> => {
  const res = await api.get<LetzteAenderung[]>('/dashboard/letzte-aenderungen');
  return res.data;
};

export const getZuletztBenutzt = async (anzahl: number): Promise<ZuletztBenutzt> => {
  const res = await api.get<ZuletztBenutzt>('/dashboard/zuletzt-benutzt', {
    params: { anzahl },
  });
  return res.data;
};

// ── Dashboard-Profile ──────────────────────────────────────

export const dashboardProfilesService = {
  list: async (): Promise<DashboardProfile[]> => {
    const res = await api.get<DashboardProfile[]>('/dashboard/profiles');
    return res.data;
  },

  create: async (name: string, widgets?: WidgetLayoutItem[]): Promise<DashboardProfile> => {
    const res = await api.post<DashboardProfile>('/dashboard/profiles', {
      name,
      widgets: widgets || [],
    });
    return res.data;
  },

  update: async (
    id: number,
    data: { name?: string; widgets?: WidgetLayoutItem[] },
  ): Promise<DashboardProfile> => {
    const res = await api.put<DashboardProfile>(`/dashboard/profiles/${id}`, data);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/dashboard/profiles/${id}`);
  },

  activate: async (id: number): Promise<DashboardProfile> => {
    const res = await api.patch<DashboardProfile>(`/dashboard/profiles/${id}/activate`);
    return res.data;
  },
};
